var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'income.add', link: 'income-add'},"title":_vm.$t('income.text')}}),_c('List',{attrs:{"dataList":_vm.incomeList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"deletes":[_vm.deleted, null],"formats":[
          {name: 'item'}, 
          {name: 'for_date', type: 'date'},
          {name: 'received_date', type: 'date'},
          {name: 'amount', type: 'currency', sign: '$'} ],"fields":[ 
          ("project_code: " + (_vm.$t('project.text'))),
          ("ref_no: " + (_vm.$t('income.ref_no'))),
          ("for_date: " + (_vm.$t('income.date'))),
          ("received_date: " + (_vm.$t('income.received_date'))),
          ("amount: " + (_vm.$t('income.amount'))),
          ("item: " + (_vm.$t('income.item-type')))
        ],"filter":{
          search: ['income_expenses.ref_no'],
          dropdown:[],
          date: {
            title: 'income.date',
            field: 'income_expenses.for_date'
          }
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }